module.exports = __webpack_public_path__ + "static/face-filter-c37cbcd0cd3076084f61d60a94a610fc.webm";